module.exports = __webpack_public_path__ + "static/media/ImgMBTI_RPIC.9545abb7.png";